module.exports = __webpack_public_path__ + "static/media/hotels-icon.9779476d.PNG";